export default function HeroSection() {
  return (
    <div>
      {/* Hero section with background image */}
      <section 
        id="home" 
        className="relative h-[100vh] sm:h-[67vh] flex items-center justify-center scroll-mt-16 sm:scroll-mt-20"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/7a5fc5b9288129e09a9bcd45a63c9819.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        {/* Enhanced overlay for better text contrast */}
        <div className="absolute inset-0 bg-gradient-to-br from-black/30 via-black/20 to-black/40"></div>
        
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center z-10">
          <div className="max-w-5xl mx-auto">
            <div className="mb-3 sm:mb-6">
              <p className="text-sm sm:text-base md:text-lg text-white font-medium tracking-wide drop-shadow-2xl" 
                 style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8), 0 0 8px rgba(0,0,0,0.6)' }}>
                株式会社ソーシャルパス
              </p>
            </div>
            <div className="mb-3 sm:mb-6">
              <h1 className="text-2xl sm:text-3xl md:text-3xl lg:text-4xl font-bold leading-tight text-white drop-shadow-2xl px-4"
                  style={{ textShadow: '3px 3px 6px rgba(0,0,0,0.9), 0 0 12px rgba(0,0,0,0.7), 0 0 20px rgba(0,0,0,0.5)' }}>
                こどもたちに信じられる<br className="sm:hidden" />未来を
              </h1>
            </div>
            <div className="mb-4 sm:mb-8">
              <p className="text-base sm:text-lg md:text-xl text-white leading-relaxed font-medium drop-shadow-2xl px-4 text-center"
                 style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8), 0 0 8px rgba(0,0,0,0.6)' }}>
                真実とディープフェイクが混在する<br className="sm:hidden" />ポスト・リアル社会に向けて
              </p>
            </div>
          </div>
        </div>
        
        {/* Scroll indicator */}
        <div className="absolute bottom-4 sm:bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-10">
          <div className="bg-white/80 backdrop-blur-sm rounded-full p-1.5 sm:p-3 border border-gray-300 shadow-lg">
            <i className="ri-arrow-down-line text-gray-700 text-xl sm:text-3xl drop-shadow-lg"></i>
          </div>
        </div>
      </section>

      {/* Content section outside background image */}
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto">
            <div className="text-base sm:text-lg md:text-xl text-gray-800 leading-relaxed space-y-6 sm:space-y-8 text-left">
              <p className="font-medium">
                情報ネットワーク社会において、私たちは、どの情報を信じ悪意ある情報からどのように身を守ったらいいのか。生成AIによるディープフェイクは、現実と虚構との境界を曖昧にし、同時に混在するポスト・リアル社会を加速していきます。
              </p>
              <p className="font-medium">
                誰もが気軽に交流でき情報の発信者になれるソーシャルネットワークは、私たちの生活に浸透し人々の判断や行動に大きな影響力をもたらしています。
一方で、高度に偽装された虚偽の情報発信や詐欺行為が、社会問題として深刻の度合いを急速に高めてきています。
              </p>
              <p className="font-medium">
                私たちは、こうした混迷した情報環境において、信頼できる情報流通を促し、誰もが安心して情報を拠り所とできる社会の構築を目指します。信頼できる情報への道しるべとなり、こどもたちに信じられる未来を拓くことが、私たちの使命です。
              </p>
              <div className="pt-6 sm:pt-8">
                <p className="text-base sm:text-lg md:text-xl text-gray-700 font-medium text-right">
                  代表取締役　三村 昌裕
                </p>
              </div>
            </div>

            {/* 添付画像を中央配置 */}
            <div className="mt-8 sm:mt-12 flex justify-center">
              <div className="w-full max-w-[200px] sm:max-w-sm">
                <img 
                  src="https://static.readdy.ai/image/5743fa161097a13fb02471cc7f354468/bbf1453622b6f9942135c2ec99b0de72.png"
                  alt="ソーシャルパスの概念図"
                  className="w-full h-auto rounded-lg"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
